<template lang="pug">
  .pho-radio
    v-radio-group(
      v-model="lazyValue"
      :mandatory="mandatory"
      :disabled="disabled"
      :row="row"
    )
      template(v-slot:label)
        small {{ title }}
      v-radio(
        v-for="(item,index) in items"
        :key="index"
        :value="item.value"
        :color="item.color"
      )
        template(v-slot:label)
          span.pt-0 {{ item.text }}
</template>
<script>
import { useModelAutoBinding } from '@/helpers/misc/binding';

export default {
  name: 'PhoRadio',
  props: {
    value: {
      type: [String, Number, Boolean, Object]
    },
    items: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    mandatory: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { lazyValue } = useModelAutoBinding(emit, props);

    return {
      lazyValue,
    };
  },
};

</script>
